import { axiosClientAdmin } from '@/lib/auth';
import { MonitoringZoneDto, ProjectScheduleDto } from './siteApi';

export interface ZoneForm {
  description?: string;
  videoProcessorIds?: string[];
  schedule?: ProjectScheduleDto;
}

export interface MonitoringZoneCrudded {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  zone?: MonitoringZoneDto;
}

export const createZone = async (
  projectId: string,
  body: ZoneForm
): Promise<MonitoringZoneCrudded> => {
  const { data } = await axiosClientAdmin.post<MonitoringZoneCrudded>(
    `/project/${projectId}/zone/create`,
    body
  );
  return data;
};

export const fetchZone = async (
  projectId: string,
  zoneId: string
): Promise<MonitoringZoneCrudded> => {
  const { data } = await axiosClientAdmin.get<MonitoringZoneCrudded>(
    `/project/${projectId}/zone/${zoneId}`
  );
  return data;
};

export const updateZone = async (
  projectId: string,
  zoneId: string,
  body: ZoneForm
): Promise<MonitoringZoneCrudded> => {
  const { data } = await axiosClientAdmin.post<MonitoringZoneCrudded>(
    `/project/${projectId}/zone/${zoneId}`,
    body
  );
  return data;
};

export const deleteZone = async (
  projectId: string,
  zoneId: string
): Promise<MonitoringZoneCrudded> => {
  const { data } = await axiosClientAdmin.delete<MonitoringZoneCrudded>(
    `/project/${projectId}/zone/${zoneId}`, {data : new FormData()}
  );
  return data;
};
